import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/vehicle'
  },
  {
    path: '/vehicle',
    name: 'Vehicle',
    component: () => import('../views/Vehicle.vue'),
    meta: { title: '车辆' }
  },
  {
    path: '/health',
    name: 'Health',
    component: () => import('../views/Health.vue'),
    meta: { title: '健康度' }
  },
  {
    path: '/dtc',
    name: 'Dtc',
    component: () => import('../views/Dtc.vue'),
    meta: { title: '故障码' }
  },
  {
    path: '/claims',
    name: 'Claims',
    component: () => import('../views/Claims.vue'),
    meta: { title: '索赔' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { title: '我的' }
  },
  {
    path: '/demo',
    name: 'Demo',
    component: () => import('../views/Demo.vue'),
    meta: { title: '蓝牙设备' }
  }
]

const router = new VueRouter({
  routes
})

export default router
